import termCategoryQueries from '@apis/queries/termCategoryQueries';
import { useQuery } from '@tanstack/react-query';

function useTermCategoryHistory() {
    const { data } = useQuery(termCategoryQueries.history());
    return data?.categories;
}

export default useTermCategoryHistory;
